import checklistApi from '@/api/checklistsAPI'

const state = {
  loadedChecklist: null
}

const getters = {

}

const actions = {
  view ({ commit }) {
    commit('setLoading', true, { root: true })
    checklistApi.view()
      .then(resp => {
        console.log(resp)
        commit('setLoading', false, { root: true })
        commit('setChecklist', resp.data.checklist)
      })
      .catch(error => {
        commit('setLoading', false, { root: true })
        commit('setError', error, { root: true })
        console.log(error)
      })
  },
  update ({ commit }) {
    checklistApi.update(this.state.checklists.loadedChecklist)
      .then(resp => {
        commit('setChecklist', resp.data.checklist)
      })
      .catch(error => {
        commit('setError', error, { root: true })
        console.log(error)
      })
  }
}

const mutations = {
  setChecklist (state, checklist) {
    state.loadedChecklist = checklist
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
